module.exports = __webpack_public_path__ + "img/pencil.cc929e80.svg";